let baseUrl = '';
if (window.konfig && window.konfig.baseUrl) {
	baseUrl = window.konfig.baseUrl;
}

export default baseUrl;



/** WEBPACK FOOTER **
 ** ./frontend/utils/baseUrl.js
 **/